export default __webpack_public_path__ + "static/media/jenny-roderick-untermyergarden-palma-wedding-164.3ffe2f64.jpg";